import * as z from 'zod';

import {
  nullableNumericQuerySchema,
  nullableNumericToNumericStringConverter,
  nullableStringToNullableFloatConverter,
  numericStringFormSchema,
} from './numeric-value';

export const percentageInput = {
  defaultValue: () => '',
  querySchema: nullableNumericQuerySchema,
  formSchema: numericStringFormSchema,
  mutationSchema: () => z.number().min(0).max(100).nullable(),
  queryToFormConverter: nullableNumericToNumericStringConverter,
  formToUpdateConverter: nullableStringToNullableFloatConverter,
};
